const INCP = 'Catálogo INPC (Índice Nacional de Precios al Consumidor)';

export const descuento = `# Model
# Descuento: Instancia de Tipo De Descuento (Mismo registro que contiene el script)
# Cargo: Instancia del cargo al que pertenece el descuento.
# INPC: ${INCP}, instancia de queryset (Manager de consulta).
# Lógica\n
# Varible de salida
output = 0\n`;

export const actualizacion = `# Model
# Actualizacion: Instancia de tipo de actualización (Mismo registro que contiene el script)
# Cargo: Instancia del cargo al que pertenece la actualización.
# INPC: ${INCP}, instancia de queryset (Manager de consulta).
# Lógica\n
# Varible de salida
output = 0\n`;

export const cargo = `# Model
# Cargo: Instancia de cargo
# INPC: ${INCP}, instancia de queryset (Manager de consulta).\n
# Lógica\n
# Varible de salida
output = 0\n`;

export const recargo = `# Model
# Recargo: Instancia de Tipo De Recargo (Mismo registro que contiene el script)
# Cargo: Instancia del cargo al que pertenece el recargo.
# INPC: ${INCP}, instancia de queryset (Manager de consulta).\n
# Lógica\n
# Varible de salida
output = 0\n`;

export default {
  descuento,
  actualizacion,
  recargo,
  cargo,
};
